import gql from 'graphql-tag'


export const GENERATE_TOKEN = gql`
    mutation generateToken($channelId:String!){
        generateToken(channelId:$channelId)
    }
`